import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { updateDataset, cancelForm, getDatasetInfo } from '../../actions/superadmin';
import { storeWithExpiration } from '../../utils/common';
import { VALID_URL_REGEX } from '../../config/app_config';

import SuperadminEditForm from './SuperadminEditForm';

const FORM_ID = 'superadminEditForm';

export class SuperadminEditFormContainer extends React.Component {
  static propTypes = {
    invalid: PropTypes.bool.isRequired,
    dataset: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    updateDatasetAction: PropTypes.func.isRequired,
    getDatasetInfoAction: PropTypes.func.isRequired,
    currDataset: PropTypes.number.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    cancelFormAction: PropTypes.func.isRequired,
  };

  componentWillMount = () => {
    const { getDatasetInfoAction, currDataset } = this.props;
    const token = storeWithExpiration.get('token');
    getDatasetInfoAction(token, currDataset);
  };

  performUpdateDataset = params => {
    const { dataset, updateDatasetAction, currDataset } = this.props;
    const token = storeWithExpiration.get('token');
    const datasetInfo = {
      status: params.status,
      name: params.name,
      s3Path: params.s3Path === '' ? null : params.s3Path.trim(),
      searchHost: params.searchHost === '' ? null : params.searchHost.trim(),
      customType: params.customType === '' ? null : params.customType,
      code: params.code === '' ? null : params.code.trim(),
      listType: dataset.listType,
      listGeo: dataset.listGeo,
      incrementalUpdates: params.incrementalUpdates || false,
      autoVersionUpdates: params.autoVersionUpdates || false,
      state: params.state,
    };
    updateDatasetAction(token, datasetInfo, currDataset);
  };

  render() {
    const {
      invalid,
      dataset,
      handleSubmit,
      submitting,
      isAdmin,
      currDataset,
      cancelFormAction,
    } = this.props;

    return (
      <div>
        <SuperadminEditForm
          invalid={invalid}
          dataset={dataset}
          handleSubmit={handleSubmit}
          updateDatasetFunction={this.performUpdateDataset}
          submitting={submitting}
          isAdmin={isAdmin}
          currDataset={currDataset}
          cancelFormFunction={cancelFormAction}
        />
      </div>
    );
  }
}

const validate = values => {
  const errors = {};
  if (!values.name || values.name === '') {
    errors.name = 'Required';
  }
  if ((values.s3path && !values.searchHost) || values.searchHost === '') {
    errors.searchHost = 'Required';
  }
  if (values.searchHost && !VALID_URL_REGEX.test(values.searchHost)) {
    errors.searchHost = 'Must be valid URL';
  }
  return errors;
};

function mapStateToProps(state) {
  const { superadmin, data } = state;
  const dataset = superadmin.get('dataset');
  const currDataset = data.get('currDataset');
  const isAdmin = data.get('isAdmin');
  const initialValues = {
    id: dataset.id,
    accountId: dataset.accountId,
    providerDataSetNum: dataset.providerDataSetNum === null ? '' : dataset.providerDataSetNum,
    name: dataset.name === null ? '' : dataset.name,
    listType: dataset.listType,
    listGeo: dataset.listGeo,
    status: dataset.status,
    code: dataset.code === null ? '' : dataset.code,
    s3Path: dataset.s3Path === null ? '' : dataset.s3Path,
    searchHost: dataset.searchHost === null ? '' : dataset.searchHost,
    customType: dataset.customType === null ? '' : dataset.customType,
    incrementalUpdates:
      dataset.incrementalUpdates === undefined ? false : dataset.incrementalUpdates,
    autoVersionUpdates:
      dataset.autoVersionUpdates === undefined ? false : dataset.autoVersionUpdates,
    createdBy: dataset.createdBy,
    createdOn: dataset.createdOn,
    updatedBy: dataset.updatedBy,
    updatedOn: dataset.updatedOn,
    state: dataset.state,
  };
  return { currDataset, dataset, superadmin, initialValues, isAdmin };
}

const SuperadminEditFormContainerRF = reduxForm({
  form: FORM_ID,
  validate,
  enableReinitialize: true,
})(SuperadminEditFormContainer);

export default connect(mapStateToProps, {
  getDatasetInfoAction: getDatasetInfo,
  updateDatasetAction: updateDataset,
  cancelFormAction: cancelForm,
})(SuperadminEditFormContainerRF);
